import { DateRange } from '../select-period-date-range.component';

// TODO don't know if it will be calendar dates or cache dates
export function dateRangeForIndex(
    periodDateRanges: DateRange[],
    current: DateRange,
    delta: number,
    maxShown: number,
): {
    dateRange: DateRange;
    periodCanGoLeft: boolean;
    periodCanGoRight: boolean;
} {
    const drIndex = periodDateRanges.findIndex((e) => e === current);
    const index = Math.min(
        Math.max(drIndex + delta, 0),
        periodDateRanges.length - maxShown,
    );
    const dateRange = periodDateRanges[index];
    const periodCanGoLeft = index > 0;
    const periodCanGoRight = index < periodDateRanges.length - maxShown;

    return { dateRange, periodCanGoLeft, periodCanGoRight };
}
